import {config} from '../config'
import httpService from "./HttpService";
import RepresentativeInterface from "../interfaces/representative.interface";
import {getURLSearchParams} from "../utils/helpers";

const REPRESENTATIVE_URL = `${config.baseUrl}${config.suffixApi}${config.versionApi}/representatives/profile`;
const UPDATE_REPRESENTATIVE_URL = `${config.baseUrl}${config.suffixApi}${config.versionApi}/representatives`;
const INVITE_REPRESENTATIVE_URL = `${config.baseUrl}${config.suffixApi}${config.versionApi}/representatives/invite`;
const GET_REPRESENTATIVE_USERS_URL = (managementCompanyId: number) => `${config.baseUrl}${config.suffixApi}${config.versionApi}/representatives/users/${managementCompanyId}`;

export const getRepresentative = ():Promise<RepresentativeInterface> => {
  const applicationContext = localStorage.getItem("applicationContext");
  return httpService.getResource<RepresentativeInterface>(REPRESENTATIVE_URL, getURLSearchParams({applicationContext}))
}
export const updateRepresentative = (representative: RepresentativeInterface): Promise<void> => {
  const applicationContext = localStorage.getItem("applicationContext");
  return httpService.putResource(UPDATE_REPRESENTATIVE_URL, representative, getURLSearchParams({applicationContext}));
}

export const getRepresentatives = (managementCompanyId: number):Promise<RepresentativeInterface> => {
  return httpService.get<RepresentativeInterface>(GET_REPRESENTATIVE_USERS_URL(managementCompanyId));
}

export const sendRepresentativeInvite = (emailId: string, managementCompanyId: number):Promise<void> => {
  return httpService.post<void>(INVITE_REPRESENTATIVE_URL, {emailId, managementCompanyId});
}

export const uploadDocument = (file: File):Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);
  return httpService.upload<string>(`${config.baseUrl}${config.suffixApi}${config.versionApi}/representatives/upload-document`, formData);
}

export const getClientIpAddress = ():Promise<{ip: string}> => {
  return httpService.getResource<{ip: string}>("https://api.ipify.org?format=json");
}
